import { useCallback } from 'react';
import { FormControl } from '../../../../input/FormControl';
import { Radio } from '../../../../input/Radio';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { Wrapper } from './styles';
import { BusinessRegistrationAccountControlProps } from './types';

export const BusinessRegistrationAccountControl = ({
    title,
    description,
    value,
    checked,
    onChange,
}: BusinessRegistrationAccountControlProps) => {
    const onClick = useCallback(() => {
        if (value && onChange) {
            onChange(value);
        }
    }, [value, onChange]);

    return (
        <Wrapper onClick={onClick}>
            <FormControl width="24px">
                <Radio checked={checked} value={value} />
            </FormControl>
            <Flex>
                <Typography variant="body" weight="bold">
                    {title}
                </Typography>
                <Typography variant="body2">{description}</Typography>
            </Flex>
        </Wrapper>
    );
};
